import { EntryStatusName } from "@web/models";

export const ENTRY_STATUS_COLORS: Record<EntryStatusName, string> = {
  RED: "#D04056",
  ORANGE: "#F1AA59",
  GREEN: "#1CA9AD",
  "NO-STATUS": "#ccc",
};
